import { Line, SliceTooltipProps } from '@nivo/line'
import AutoSizer from 'react-virtualized-auto-sizer'

interface Props {
  data: any[]
  title?: string
  colors?: any
  yLabel?: string
  hideLegend?: boolean
}
interface Size {
  height: number
  width: number
}

const LineChart = ({ data, title, colors, yLabel, hideLegend }: Props) => {
  let minValue = Number.POSITIVE_INFINITY

  console.log(data)

  if (!Array.isArray(data) || data.includes(undefined)) return null

  data.forEach((line: any) => {
    let min = Math.min(...line.data.map((point: any) => point.y))
    if (min < minValue) minValue = min
  })

  let points = data[0].data.length
  let minTime = data[0].data[0].x
  let maxTime = data[0].data[data[0].data.length - 1].x
  let diffTime = new Date(maxTime).getTime() - new Date(minTime).getTime()
  let diffDays = diffTime / (1000 * 3600 * 24)

  const formatTime = () => {
    if (diffDays <= 1) return '%H:%M'
    if (diffDays > 1 && diffDays <= 7) return '%m/%d %H:%M'
    if (diffDays > 7) return '%m/%d'
    if (diffDays > 180) return '%m'
  }

  const formatTickValues = (width: number) => {
    return Math.ceil(width / 100)
  }

  const customSliceTooltip = ({ slice }: SliceTooltipProps) => {
    return (
      <div className='customSliceTooltip'>
        <div>
          <table>
            <tbody>
              <tr>
                <th colSpan={3}>{slice.points[0].data.xFormatted}</th>
              </tr>

              {slice.points.map((point, index) => (
                <tr key={index}>
                  <td>
                    <span className='color' style={{ background: point.serieColor }}></span>
                  </td>
                  <td>{`${point.serieId}:`}</td>
                  <td>
                    <span className='value'>{point.data.yFormatted}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  return (
    <>
      {title || data[0].title}
      <AutoSizer style={{ width: '100%', height: 250 }}>
        {({ height, width }: Size) => (
          <Line
            height={250}
            width={width}
            data={data}
            margin={{ left: 60, bottom: 50, right: 20, top: 20 }}
            useMesh
            enablePoints={points < 50 ? true : false}
            enableArea
            areaBaselineValue={minValue}
            xScale={{
              type: 'time',
              format: '%Y-%m-%dT%H:%M:%S',
              useUTC: false,
            }}
            xFormat='time:%Y-%m-%d %H:%M:%S'
            yFormat={'.2f'}
            yScale={{
              type: 'linear',
              min: 'auto',
              max: 'auto',
            }}
            axisBottom={{
              format: formatTime(),
              tickValues: formatTickValues(width),
              legend: 'time scale',
              legendOffset: -12,
            }}
            axisLeft={{
              legend: yLabel || data[0].yLabel,
              legendOffset: -50,
              legendPosition: 'middle',
            }}
            colors={colors || data.map((line: any) => line.color)}
            isInteractive={true}
            enableGridY
            gridYValues={4}
            enableGridX={false}
            animate={false}
            enableSlices={'x'}
            sliceTooltip={customSliceTooltip}
            legends={
              !hideLegend && width > 420
                ? [
                    {
                      anchor: 'bottom-left',
                      direction: 'row',
                      justify: false,
                      translateX: -30,
                      translateY: 50,
                      itemsSpacing: 0,
                      itemDirection: 'left-to-right',
                      itemWidth: 150,
                      itemHeight: 20,
                      itemOpacity: 0.75,
                      symbolSize: 12,
                      symbolShape: 'circle',
                      symbolBorderColor: 'rgba(0, 0, 0, .5)',
                      effects: [
                        {
                          on: 'hover',
                          style: {
                            itemBackground: 'rgba(0, 0, 0, .03)',
                            itemOpacity: 1,
                          },
                        },
                      ],
                    },
                  ]
                : undefined
            }
          />
        )}
      </AutoSizer>
    </>
  )
}

export default LineChart
